import { createContext, useContext, useEffect, useState } from "react";
import api, { getToken, setToken, clearToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = getToken();
    if (!token) {
      setUser(false);
      setChecking(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => { setUser(res.data); try { localStorage.setItem("klt_user_cache", JSON.stringify(res.data)); } catch { /* quota */ } })
      .catch((e) => {
        const cached = localStorage.getItem("klt_user_cache");
        if (!e.response && cached) { setUser(JSON.parse(cached)); return; }
        clearToken();
        localStorage.removeItem("klt_user_cache");
        setUser(false);
      })
      .finally(() => setChecking(false));
  }, []);

  const login = async (email, password, remember) => {
    const { data } = await api.post("/auth/login", { email, password, remember });
    setToken(data.access_token, remember);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setToken(data.access_token, payload.remember);
    setUser(data.user);
    return data.user;
  };

  const loginKallitag = async (email, password, remember) => {
    const { data } = await api.post("/auth/kallitag-login", { email, password, remember });
    setToken(data.access_token, remember);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    clearToken();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, checking, login, register, loginKallitag, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
